import WsService from "../WsService";
import UserPaymentDetailsDTO from "../../domain/User/UserPaymentDetailsDTO";

const ENDPOINT_BASE = "/admin/user-payment-details";

export default class UserPaymentDetailsService {

    static retrieveByUserId(userId) {

        let endpoint = ENDPOINT_BASE + "/" + userId;

        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new UserPaymentDetailsDTO(response)
            },
            response => {
                return response;
            });
    }

    static createAndUpdateUserPaymentDetails(userId, userPaymentDetailsDTO) {

        let endpoint = ENDPOINT_BASE + "/" + userId + "/update";

        return WsService.post(endpoint, UserPaymentDetailsDTO.toJson(userPaymentDetailsDTO), 201).then(
            response => {
                return response;
            },
            response => {
                return response;
            }
        )
    }
}